/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AgricultureInputs */

const vi_nav_agriculture = /** @type {(inputs: Nav_AgricultureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nông nghiệp`)
};

/**

* @param {Nav_AgricultureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_agriculture = /** @type {((inputs?: Nav_AgricultureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AgricultureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_agriculture(inputs)
});